module.exports = __webpack_public_path__ + "assets/img/11_758.9aba1095.jpg";